import { Skeleton } from "@/components/ui/skeleton";

/**
 * Shared loading placeholder for the spreadsheet-style pages (Leads,
 * Clients, Invoices). Mimics the header → toolbar → table-grid shape so
 * the layout doesn't jump when real data arrives, replacing the old
 * full-page centered spinner.
 */
export function SpreadsheetSkeleton({
  rows = 12,
  columns = 6,
}: {
  rows?: number;
  columns?: number;
}) {
  return (
    <div className="p-3 sm:p-6 space-y-4" data-testid="skeleton-spreadsheet">
      {/* Title + primary action */}
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-2">
          <Skeleton className="h-7 w-40" />
          <Skeleton className="h-4 w-56" />
        </div>
        <Skeleton className="h-9 w-28 shrink-0" />
      </div>

      {/* Search + filter toolbar */}
      <div className="flex flex-wrap items-center gap-2">
        <Skeleton className="h-9 w-full max-w-xs" />
        <Skeleton className="h-9 w-24" />
        <Skeleton className="h-9 w-24" />
      </div>

      {/* Table */}
      <div className="rounded-lg border border-card-border overflow-hidden">
        {/* Column header row */}
        <div className="flex items-center gap-4 px-4 py-3 border-b border-card-border bg-muted/30">
          {Array.from({ length: columns }).map((_, i) => (
            <Skeleton key={i} className="h-4 flex-1" />
          ))}
        </div>
        {/* Body rows */}
        <div className="divide-y divide-card-border">
          {Array.from({ length: rows }).map((_, r) => (
            <div key={r} className="flex items-center gap-4 px-4 py-3">
              {Array.from({ length: columns }).map((_, c) => (
                <Skeleton key={c} className="h-4 flex-1" />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
